import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { formatFetchedCustomIcons, validateNonAsciiChars } from "../../../../utils/commonUtils";
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import JSZip from 'jszip';
import { Alert } from "@material-ui/lab";
import { IconSelector } from "../../../atoms/IconSelectorV2";
import { useMemo } from "react";

const useStyles = makeStyles((theme) => ({
	// Define your custom styles here
	textCapitalise: {
		textTransform: 'capitalize' 
	},
	formControl: {
		minWidth: 120,
		width: "100%"
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	}
  }));

const CustomBlueprintImporter = (props) => {
  const classes = useStyles();
  const {icon, setIcon} = props;

  const [file, setFile] = useState("");
  const [blueprintName, setBlueprintName] = useState("");
  const [selectedPsVersion, setSelectedPsVersion] = useState(null);
  const [descError, setDescError] = useState(null)
  const [psVersionAlert, setPsVersionAlert] = useState(null);
  const [disableSelectBlueprint, setDisableSelectBlueprint] = useState(false)

  const allowedFiles = [".json"];
  const isValidFile = (file) => (file.type === "application/json" || file.type === "application/zip" || file.type === "application/x-zip-compressed");

  /* Handle file upload */
  const handleFileSelection = async (e) => {
    const selectedFile = e.target.files[0];
    const fileName = selectedFile?.name;
    setFile(fileName);
    let isValid = isValidFile(selectedFile);
    console.log({isValid}, 'selected file validity')
    if (!isValid) {
      props.setImportError("Please upload a compressed file (.zip)");
      props.setInvalidFile(true);
    } else {
      setDisableSelectBlueprint(true)
      let {blueprintJson, isPlatformSchemaJsonPresent } = await handleZipFile(selectedFile) || {};
      setDisableSelectBlueprint(false)

      if(blueprintJson && blueprintJson?.icon && blueprintJson?.iconSource === "library"){
        setIcon(formatFetchedCustomIcons({
          icon: blueprintJson?.icon,
          iconSource: blueprintJson?.iconSource
        }))
      }
      
      if(!blueprintJson?.platformSchemaVersion && !isPlatformSchemaJsonPresent){
        setPsVersionAlert('The blueprint you trying to import does not contain any platform schema version!')

      }else{
        let isVersionAvailable = props?.availableVersions?.find(item => item?.version === blueprintJson?.platformSchemaVersion);
        
        if (!isVersionAvailable && !isPlatformSchemaJsonPresent) {
          setPsVersionAlert(`The platform schema version(${blueprintJson?.platformSchemaVersion}) of the blueprint is not available'}`)
        }
      }
      
      
      props.setImportError("");
      props.setInvalidFile(false);
      props.setCustomBlueprintFile(selectedFile);
      const fileBaseName = fileName?.substring(0, fileName.lastIndexOf('.'))
      const supportedName = fileBaseName.replace(/[\s\W-]+/g, "");
      if (props.selectedBlueprintName.current === "") {
        setBlueprintName(supportedName);
        props.setCustomBlueprintName(supportedName);
      }
    }
  };

  const handleZipFile = async(file) => {
    // Check if the file type is zip
    if (file && (file.type === 'application/zip' || file.type === "application/x-zip-compressed")) {
      const zip = new JSZip();
  
      try {
        // Load the zip file
        const zipContent = await zip.loadAsync(file);
  
        // Find the first .json file in the zip directory
        const jsonFile = Object.keys(zipContent.files).find(
          (fileName) => fileName.endsWith('.json') && !fileName.includes("platform_schema")
        );

        const isPlatformSchemaJsonPresent = Object.keys(zipContent.files).some(
          (fileName) => fileName.endsWith('.json') && fileName.includes("hyperblox_platform_schema")
        );
  
        // If a .json file is found, return its content
        if (jsonFile) {
          const fileContent = await zipContent.files[jsonFile].async('string');
          return {blueprintJson: JSON.parse(fileContent), isPlatformSchemaJsonPresent}; // Parse and return the JSON content
        } else {
          return {blueprintJson: false, isPlatformSchemaJsonPresent: isPlatformSchemaJsonPresent}; // No .json file found in zip
        }
      } catch (error) {
        console.error('Error reading zip file:', error);
        return null;
      }
    } else {
      try {
        const text = await file.text();
        return {blueprintJson: JSON.parse(text), isPlatformSchemaJsonPresent: false}; // Parse and return JSON content
      } catch (error) {
        console.error('Error reading JSON file:', error);
        return null;
      }
    }
  }

  


  return (
    <React.Fragment>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={3}>
          <Button variant="contained" id="select_blueprint_btn" disabled={props?.loading || disableSelectBlueprint ? true : false} component="label" color="primary" style={{ textTransform: 'capitalize' }}>
            select blueprint
            <input type="file" hidden onChange={(e) => handleFileSelection(e)} />
          </Button>
        </Grid>

        <Grid item xs={9}>
          {file != "" && <Box color="text.primary">{file}</Box>}
        </Grid>

      </Grid>

      {
        psVersionAlert &&
        <Alert severity="warning">
          {psVersionAlert}
        </Alert>
      }

      <Grid container xs={12} style={{gap: '1rem', flexWrap: 'nowrap', paddingTop: '1rem'}}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            variant="outlined"
            label={"Blueprint Name"}
            name="blueprint_name"
            placeholder={"Blueprint Name"}
            value={blueprintName}
            onChange={(e) => {
              setBlueprintName(e.target.value);
              props.setCustomBlueprintName(e.target.value);
            }}
          />
        </Grid>
      </Grid>
      <br />
      <TextField
        style={{marginBottom:'10px'}}
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        placeholder={"Description"}
        label={"Description"}
        name="blueprint_desc"
        onChange={(e) => {
          if(validateNonAsciiChars(e.target.value) !== true){
            setDescError(validateNonAsciiChars(e.target.value))
          }else{
            setDescError(false)
          }
          props.setCustomBlueprintDesc(e.target.value)
        }}
        error={descError ? true : false}
				helperText={descError || ''}
      />
      
      <IconSelector isBlueprintCreate={true}  setSelectedIcon={setIcon} selectedIcon={icon}  defaultSearchTag={blueprintName || ""}/>

    </React.Fragment>
  );
};

export default CustomBlueprintImporter;
